// Generic scheduler (visits, inspections, etc.)
function initScheduler() {
  const inputs = document.querySelectorAll('input[name="schedule_date"]')
  console.log('Initializing scheduler, found inputs:', inputs.length)

  inputs.forEach((input) => {
    input.addEventListener('change', (event) => {
      console.log('Day changed!')
      const url = event.target.dataset.url
      const frameId = event.target.dataset.turboFrame
      console.log('URL:', url, 'Frame ID:', frameId)

      if (url && frameId) {
        fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'text/vnd.turbo-stream.html',
          },
        })
          .then((response) => {
            console.log('Response received:', response.status)
            return response.text()
          })
          .then((html) => {
            console.log('HTML received, length:', html.length)
            const turboFrame = document.getElementById(frameId)
            if (turboFrame) {
              turboFrame.innerHTML = html
              turboFrame.classList.remove('disabled', 'pointer-events-none')
              console.log('Scheduler updated!')
            } else {
              console.error('Turbo frame not found:', frameId)
            }
          })
          .catch((error) => console.error('Error fetching hours:', error))
      } else {
        console.error('Missing URL or frame ID')
      }
    })
  })
}

function initModal() {
  // Modal de confirmação de pré-agendamento
  const submitBtn = document.getElementById('submit-btn')
  const confirmationModal = document.getElementById('confirmation-modal')
  const modalClose = document.getElementById('modal-close')
  const modalConfirm = document.getElementById('modal-confirm')
  const form = document.querySelector('form')

  if (submitBtn && confirmationModal && modalClose && modalConfirm && form) {
    // Intercepta o clique no botão Enviar
    submitBtn.addEventListener('click', (e) => {
      e.preventDefault()

      // Valida se o formulário está preenchido
      if (form.checkValidity()) {
        // Abre o modal
        confirmationModal.classList.add('modal-open')
      } else {
        // Se não for válido, força a validação nativa
        form.reportValidity()
      }
    })

    // Botão "Não entendi" - apenas fecha o modal
    modalClose.addEventListener('click', () => {
      confirmationModal.classList.remove('modal-open')
    })

    // Botão "Concordo" - fecha o modal e submete o formulário
    modalConfirm.addEventListener('click', () => {
      confirmationModal.classList.remove('modal-open')
      form.submit()
    })

    // Fecha o modal ao clicar fora dele
    confirmationModal.addEventListener('click', (e) => {
      if (e.target === confirmationModal) {
        confirmationModal.classList.remove('modal-open')
      }
    })
  }
}

function initAll() {
  initScheduler()
  initModal()
}

document.addEventListener('DOMContentLoaded', initAll)
document.addEventListener('turbo:load', initAll)
